// Third party modules;
import React from 'react';

// HelpBot modules;
import api from './api/api';
import { Form, FORM, form_close } from './Form';

const Simple = () => {

   const [date, set_date] = React.useState();
   const [time, set_time] = React.useState();

   const field1 = React.useRef();

   const begin = async ({ set_form, set_warn, ...args }) => {
      // The begin() function initiates an API call to get information required to build the form. If no
      // information is needed then you can omit the begin() function or just set the form state to BUILD;
      var response = await api.fetch('sys/ping');
      if (!response.good) {
         set_warn('undefined' === typeof response.data.text ? 'Unrecognized API errror.' : response.data.text);
      } else {
         set_date(response.data.time.substr(0, 10));
      }
      set_form(FORM.BUILD);
   } // begin();

   const build = ({ set_body, set_foot, warn, ...args }) => {
      // The build() function sets the body and foot componenets and waits for the user to 
      // initiate an action on the form such as an option select, text input or submit;
      set_body(
         <>
           {warn}
           <p className="ask-henry-body-margin-bottom-x">The date is {date}</p>
           <p className="ask-henry-body-margin-bottom-x">Enter anything and click SUBMIT to get the time.</p>
           <input className="ask-henry-form-input" name="field1" placeholder="enter anything. . ." ref={field1} type="text" />
         </>
      );
      set_foot(
         <>
           <button className="ask-henry-form-button" type="submit">Submit</button>
           <button className="ask-henry-form-button" onClick={form_close} >Close</button>
         </>
      );
   } // build();

   const check = ({ set_form, set_warn, ...args }) => {
      // The check() function validates the user input, if the input is bogus, a warning message
      // is set, otherwise the form state is set to ENACT;
      if (!field1.current.value) {
         set_warn('Enter anything before you click the SUBMIT button.');
         set_form(FORM.BUILD); // Go back and wait for proper data and form submit;
      } else {
         set_form(FORM.ENACT);// Send any requests to the API;
      }
   } // check();

   const enact = async ({ set_form, set_warn, ...args }) => {
      // The enact() function does the actual work given the user inputs and options;
      var response = await api.fetch('sys/ping', api.token());
      if (!response.good) {
         if ('undefined' === typeof response.data.text) {
            set_warn('Unrecognized error returned from API.');
         } else {
            set_warn(response.data.text);
         }
         set_form(FORM.BUILD);
      } else {
         set_time(response.data.time.substr(11, 8));
         set_form(FORM.FINAL);
      }
   } // enact();

   const final = ({ set_body, set_foot, ...args }) => {
      // The final() function displays the final results and renders the close option;
      set_body(<p className="ask-henry-body-margin-bottom-x">The date is {date} and the time is {time}.</p>);
      set_foot(<button className="ask-henry-form-button" onClick={form_close} >Close</button>);
   } // final();

   return <Form begin={begin} build={build} check={check} enact={enact} final={final} title="Simple Action PopUp" />

} // <Simple />;

export default Simple;
